import React from 'react';

import useTimer from '@swf/core/hooks/useTimer';

export interface Props {
  children: React.ReactNode[];
  interval: number;
  className?: string;
}

const ContentTicker: React.FC<Props> = ({ interval, children, className }) => {
  const count = children.length;
  const timer = useTimer({});
  const index = Math.floor(timer / interval) % count;

  return count ? <div className={className}> {children[index]}</div> : null;
};

export default React.memo(ContentTicker);
